import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  ActionAuth,
  ActionVideoCall,
  ActionCompany,
  ActionCompanyContract,
  ActionUi,
} from '../../core';

export function useReduxHelper() {
  const dispatch = useDispatch();

  const resetAllReduxData = useCallback(() => {
    dispatch(ActionAuth.resetData());
    dispatch(ActionVideoCall.resetData());
    dispatch(ActionCompany.resetData());
    dispatch(ActionCompanyContract.resetData());
    dispatch(ActionUi.resetData());
  }, [dispatch]);

  return {
    resetAllReduxData,
  };
}
